import type { RxCollection, RxDatabase, RxJsonSchema } from 'rxdb'
import { createCollection } from "@/data/utils/migration.ts";


export const DELIVERY_SETTING_COLLECTION_NAME = 'delivery_settings'

export interface DeliverySetting {
  _id: string;
  distance?: number;
  zoneName?: string;
  cost?: number;
  minOrderValue?: number;
  freeFrom?: number //This delivery is free for orders worth
  color?: string
  postalCode?: string
  type: 'radius' | 'zone'
  isEnable?: boolean;
  location?: { lat: number, lng: number };
}

export const deliverySettingSchema: RxJsonSchema<DeliverySetting> = {
  title: 'deliverySetting schema',
  version: 1, // update this when schema change
  primaryKey: '_id',
  type: 'object',
  properties: {
    _id: { type: "string", maxLength: 24 },
    zoneName: { type: "string" },
    freeFrom: { type: "number" },
    color: { type: "string" },
    postalCode: { type: "string" },
    distance: { type: "number" },
    minOrderValue: { type: "number" },
    cost: { type: "number" },
    type: { type: "string" },
    isEnable: { type: "boolean" },
  },
  required: ['_id'],
}

export const DeliverySetting = {} as RxCollection<DeliverySetting>

Object.assign(window, { DeliverySetting }) // Make available global

export const createDeliverySettingCollection = async <T>(database: RxDatabase<T>): Promise<RxCollection<DeliverySetting>> => {
  return await createCollection({
    database,
    collection: DeliverySetting,
    collectionName: DELIVERY_SETTING_COLLECTION_NAME,
    version: deliverySettingSchema.version,
    schema: deliverySettingSchema,
  });
};

